import { TabValue } from '../TabNavigation/types';

export const ROUTE_TO_TAB_MAP: Record<string, TabValue> = {
  details: 0,
  questions: 1,
  vacancies: 2,
  setup: 3,
  'hiring-team': 4,
  'internal-notes': 6,
  automations: 7,
  'activity-feed': 8,
};
